export enum ListViewMode {
  Load = 'LOAD',
  TransportOrder = 'TO',
}
